import { useEffect, useRef } from 'react';
import { useMatch, useNavigate } from 'react-router';
import useAuthForms from '../useAuthForms';
import { useMarketplaceConfig } from '../../queries/marketplace';

type CasinoRouteAuthenticationOptions = {
  isAuthenticated: boolean;
  isContentBlocked: boolean;
};

export const useCasinoRouteAuthentication = ({
  isAuthenticated,
  isContentBlocked,
}: CasinoRouteAuthenticationOptions) => {
  const gameId = useMatch('/casino/game/:gameId')?.params.gameId;
  const navigate = useNavigate();
  const { isHybrid, data: marketplaceConfig } = useMarketplaceConfig();
  const { openLoginForm, openRegisterForm } = useAuthForms();
  const hasAuthenticatedSession = useRef(false);
  const requestedAuthGameId = useRef<string | null>(null);

  useEffect(() => {
    if (!gameId) {
      hasAuthenticatedSession.current = false;
      requestedAuthGameId.current = null;
      return;
    }

    if (isAuthenticated) {
      hasAuthenticatedSession.current = true;
      requestedAuthGameId.current = null;
      return;
    }

    if (hasAuthenticatedSession.current) {
      navigate('/casino', { replace: true });
      return;
    }

    if (isContentBlocked || !marketplaceConfig || requestedAuthGameId.current === gameId) {
      return;
    }

    requestedAuthGameId.current = gameId;

    if (isHybrid) {
      openLoginForm();
    } else {
      openRegisterForm();
    }
  }, [
    gameId,
    isAuthenticated,
    isContentBlocked,
    isHybrid,
    marketplaceConfig,
    navigate,
    openLoginForm,
    openRegisterForm,
  ]);
};
